import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
	const isDark = theme.mode === "dark";
	const primary = theme.palette.primary.main;

	return {
		paper: {
			borderRadius: 10,
			color: isDark ? "#f8fafc" : "#131b2e",
			backgroundColor: isDark ? "#424242" : "#ffffff",
			boxShadow: isDark
				? "0 24px 56px rgba(0, 0, 0, 0.42)"
				: "0 24px 56px rgba(15, 23, 42, 0.16)",
		},
		title: {
			padding: theme.spacing(2.5, 3, 1),
			"& h2": {
				color: isDark ? "#ffffff" : "#131b2e",
				fontSize: 20,
				fontWeight: 800,
			},
		},
		content: {
			padding: theme.spacing(1.5, 3),
			borderTop: "none",
			borderBottom: "none",
			backgroundColor: isDark ? "#424242" : "#ffffff",
		},
		message: {
			color: isDark ? "#e5e7eb" : "#4b5563",
			lineHeight: 1.6,
		},
		actions: {
			gap: theme.spacing(1),
			padding: theme.spacing(1.5, 3, 2.5),
			backgroundColor: isDark ? "#424242" : "#ffffff",
		},
		cancelButton: {
			borderRadius: 8,
			color: isDark ? "#e5e7eb" : "#4b5563",
			backgroundColor: isDark ? "#4e4e4e" : "#f3f4f6",
			textTransform: "none",
			fontWeight: 700,
			boxShadow: "none",
			"&:hover": {
				backgroundColor: isDark ? "#575757" : "#e5e7eb",
				boxShadow: "none",
			},
		},
		confirmButton: {
			borderRadius: 8,
			color: "#ffffff",
			background: `linear-gradient(135deg, ${primary} 0%, #0052cc 100%)`,
			textTransform: "none",
			fontWeight: 800,
			boxShadow: isDark
				? "0 10px 22px rgba(0, 0, 0, 0.28)"
				: "0 10px 22px rgba(0, 82, 204, 0.22)",
			"&:hover": {
				background: "linear-gradient(135deg, #0040a2 0%, #0052cc 100%)",
			},
		},
	};
});

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useStyles();

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			classes={{ paper: classes.paper }}
		>
			<DialogTitle id="confirm-dialog" className={classes.title}>{title}</DialogTitle>
			<DialogContent className={classes.content}>
				<Typography className={classes.message}>{children}</Typography>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button
					variant="contained"
					onClick={() => onClose(false)}
					color="default"
					className={classes.cancelButton}
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					color="secondary"
					className={classes.confirmButton}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
